import axios from 'axios';
import { EventoBoleteraModel } from '../../pages/boletera/eventos/models/EventoBoleteraModel';
import { NivelEntradaModel, NivelesResumen } from '../../pages/boletera/eventos/models/NivelEntradaModel';
import { SubSeccionModel, SubSeccionesResumen } from '../../pages/boletera/eventos/models/SubSeccionModel';

const API_URL = process.env.REACT_APP_API;

// ── Eventos boletera ──────────────────────────────────────────────────────────

export async function obtenerEventosBoletera(): Promise<EventoBoleteraModel[]> {
  const response = await axios.get(`${API_URL}eventos`);
  return response.data?.doc?.data?.rows || [];
}

export async function obtenerEventoBoleteraPorId(id: number): Promise<EventoBoleteraModel | null> {
  const response = await axios.get(`${API_URL}eventos/${id}`);
  return response.data?.doc?.data || null;
}

export async function crearEventoBoletera(data: Partial<EventoBoleteraModel>) {
  return axios.post(`${API_URL}eventos`, data);
}

export async function actualizarEventoBoletera(id: number, data: Partial<EventoBoleteraModel>) {
  return axios.patch(`${API_URL}eventos/${id}`, data);
}

// ── Niveles de entrada ────────────────────────────────────────────────────────

export async function obtenerNiveles(eventoId: number): Promise<NivelesResumen> {
  const response = await axios.get(`${API_URL}eventos/${eventoId}/niveles`);
  return response.data?.doc?.data;
}

export async function crearNivel(eventoId: number, data: Partial<NivelEntradaModel>) {
  return axios.post(`${API_URL}eventos/${eventoId}/niveles`, data);
}

export async function actualizarNivel(eventoId: number, id: number, data: Partial<NivelEntradaModel>) {
  return axios.patch(`${API_URL}eventos/${eventoId}/niveles/${id}`, data);
}

export async function eliminarNivel(eventoId: number, id: number) {
  return axios.delete(`${API_URL}eventos/${eventoId}/niveles/${id}`);
}

export async function cambiarEstadoEvento(id: number, accion: 'publicar' | 'pausar' | 'despublicar') {
  return axios.patch(`${API_URL}eventos/${id}/estado`, { accion });
}

// ── Sub-secciones ─────────────────────────────────────────────────────────────

export async function obtenerSubsecciones(nivelId: number): Promise<SubSeccionesResumen> {
  const response = await axios.get(`${API_URL}niveles/${nivelId}/subsecciones`);
  return response.data?.doc?.data;
}

export async function crearSubSeccion(nivelId: number, data: Partial<SubSeccionModel>) {
  return axios.post(`${API_URL}niveles/${nivelId}/subsecciones`, data);
}

export async function actualizarSubSeccion(nivelId: number, id: number, data: Partial<SubSeccionModel>) {
  return axios.patch(`${API_URL}niveles/${nivelId}/subsecciones/${id}`, data);
}

export async function eliminarSubSeccion(nivelId: number, id: number) {
  return axios.delete(`${API_URL}niveles/${nivelId}/subsecciones/${id}`);
}

// ── Asientos ──────────────────────────────────────────────────────────────────

export async function generarAsientos(
  subSeccionId: number,
  data: { num_filas: number; asientos_por_fila: number; fila_inicio?: string }
) {
  return axios.post(`${API_URL}subsecciones/${subSeccionId}/asientos/generar`, data);
}

export async function limpiarAsientos(subSeccionId: number) {
  return axios.delete(`${API_URL}subsecciones/${subSeccionId}/asientos`);
}

export async function obtenerAsientos(subSeccionId: number) {
  const response = await axios.get(`${API_URL}subsecciones/${subSeccionId}/asientos`);
  return response.data?.doc?.data?.rows || [];
}
